<div class="container">
  @if (isLoading) {
  <aw-spinner [fullScreen]="true"></aw-spinner>
  }
  <aw-toast></aw-toast>

  <aw-bread-crumb [breadcrumbs]="breadcrumbs()" ariaLabel="Third-Party Integration Details"></aw-bread-crumb>

  <aw-divider
    [inset]="false"
    [middleInset]="false"
    [title]="'Third-Party Integration Details'"
    [altColor]="false"
    [actions]="headerButtonActions()"
  >
  </aw-divider>

  <div class="info-container">
    <div>
      @for (item of integrationInfoDividers(); track $index) {
      <div class="inset">
        <span class="aw-b-1 aw-text-secondary">{{ item.title }}</span>
        <span class="aw-b-1-medium aw-text-primary">{{ item.info }}</span>
      </div>
      <aw-divider></aw-divider>
      }
    </div>

    <div class="divider-container">
      @for (item of integrationDateDividers(); track $index) {
      <div class="inset">
        <span class="aw-b-1 aw-text-secondary">{{ item.title }}</span>
        <span class="aw-b-1-medium aw-text-primary">{{ item.info }}</span>
      </div>
      <aw-divider></aw-divider>
      }
    </div>

    <div class="customers-container">
      <aw-divider
        [inset]="false"
        [middleInset]="false"
        [subTitle]="'Third-Party Integration Customers'"
        [altColor]="true"
      >
      </aw-divider>
      <app-table-action-bar>
        <aw-search
          class="table-action-bar__search"
          [(ngModel)]="customerSearchValue"
          (ngModelChange)="onSearchTable(customerSearchValue)"
          ariaLabel="Search Customers"
          [placeholder]="'Search'"
        >
          <mat-icon [svgIcon]="'search'" position="prefix"></mat-icon>
        </aw-search>

        @if (organization === 'assetworks-employee') {
        <aw-select-menu
          class="table-action-bar__filter"
          ariaLabel="Filter on Associated"
          placeholder="Filter on Associated"
          [formControl]="associatedFilter"
          [multiSelectListItems]="associatedFilterOptions"
        >
          <aw-form-field-label>Associated</aw-form-field-label>
        </aw-select-menu>
        }

        @if (organization === 'assetworks-employee' && userPermissions['canEdit']) {
        <button
          type="button"
          AwButton
          [buttonType]="'outlined'"
          [disable]="disableCustomerChangeStatus"
          (click)="openChangeCustomerStatus = true"
        >
          Change Status
        </button>
        <button
          type="button"
          AwButton
          [buttonType]="'outlined'"
          [disable]="disableCustomerAssociate"
          (click)="openAssociate(checkedRows)"
        >
          Associate
        </button>
        }

      </app-table-action-bar>
      <aw-table
        [columnsDefinition]="customersColumnsDefinition"
        [tableData]="customersTableData()"
        [sortDisabled]="false"
        [optionsMenuHandler]="organization === 'assetworks-employee' ? rowActions : undefined"
        (checkboxList)="checkBoxActionHandler($event)"
      >
      </aw-table>

      <aw-dialog
        [visible]="openDeleteCustomerDialogSingle"
        [dialogOptions]="dialogOptionsDeleteSingle"
        (primaryAction)="deleteCustomerFormSubmit()"
        (secondaryAction)="dialogFormCloseHandler('delete')"
        ariaLabel="Disassociate customer"
      >
      </aw-dialog>
      <aw-dialog
        [visible]="openChangeCustomerStatus"
        [formFieldsData]="changeStatusFormFields()"
        [dialogOptions]="dialogOptionsChangeStatus"
        (primaryAction)="changeCustomerStatusFormSubmit($event)"
        (secondaryAction)="dialogFormCloseHandler('change-status')"
        ariaLabel="Change customer status"
      >
      </aw-dialog>
      <aw-dialog
        [visible]="openAssociateCustomerDialog"
        [dialogOptions]="dialogOptionsAssociate"
        (primaryAction)="associateCustomersFormSubmit()"
        (secondaryAction)="dialogFormCloseHandler('associate')"
        ariaLabel="Associate customer"
      >
      </aw-dialog>
    </div>

    @if (hasAssociatedCustomers()) {
      <div class="api-access-container">
        <aw-divider
          [inset]="false"
          [middleInset]="false"
          [subTitle]="'API Access'"
          [altColor]="true"
        ></aw-divider>

        <app-aw-dropdown-form
          [options]="associatedCustomerOptions()"
          [title]="'Select Customer'"
          (currentOption)="onCustomerSelected($event)"
        ></app-aw-dropdown-form>

        @if (selectedCustomerId) {
          <app-api-access-section
            [organizationId]="selectedCustomerId"
            [authorizedParty]="integrationInfo?.organizationId ?? ''"
            (toastMessage)="buildToastMessage($event.message, $event.variant)"
          ></app-api-access-section>

          <app-api-access-section
            [mode]="'write'"
            [organizationId]="selectedCustomerId"
            [authorizedParty]="integrationInfo?.organizationId ?? ''"
            (toastMessage)="buildToastMessage($event.message, $event.variant)"
          ></app-api-access-section>
        }
      </div>
    }
  </div>
</div>
